import { IContextMenuService } from "../IContextMenuService";
import { ContextMenuItem } from "../../../model/contextmenu/ContextMenuItem";
import { ContextMenuState } from "../../../model/contextmenu/ContextMenuState";
import { ContextMenuServiceResponse } from "../../../model/contextmenu/ContextMenuServiceResponse";

import { BfxBlotterOrdersContextMenuState } from "../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";

import { IBlotterOrdersContextMenuService } from "../bfx-blotter-orders/IBlotterOrdersContextMenuService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const FIND_ORDERS_CONTEXT_MENU_SERVICE: string = "FindOrdersContextMenuServiceChannel";

export interface IFindOrdersContextMenuService extends IBlotterOrdersContextMenuService {
  getMenuItems(
    selectedIds: Array<string>,
    menuState: ContextMenuState,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>>;
}
